<app-i18n-dictionary>
    <span [attr.transid]="titleTextId" i18n="@@collection-page_title">Catalog</span>
</app-i18n-dictionary>

<mat-sidenav fixedInViewport class="sidenav-advanced-search" (closedStart)="onCloseAdvancedSearch()" position="end"
             [opened]="isAdvancedSearchOpen$ | async">
    <app-advanced-search-page></app-advanced-search-page>
</mat-sidenav>

<div class="container">
    <div class="teaser">
        <div class="headline">
            <div class="welcome">
                <div i18n="@@collection-page_title">Catalog</div>
            </div>
            <div class="announcement">
                <app-cms-block blockId="collection_page_headline"></app-cms-block>
            </div>
        </div>
        <div class="gallery-container">
            <gallery [loop]="true" [thumb]="false" [loadingStrategy]="'preload'" [gestures]="true"
                     [autoPlay]="true" [playerInterval]="5000" [counter]="false" [imageSize]="'cover'"
                     [items]="previewImages" [dots]="true"
                     class="image-gallery"></gallery>
        </div>
    </div>

    <div class="content-wrapper">
        <div class="pre-search-text" fxLayout="column" fxLayoutAlign="center center">
            <div i18n="@@collection-page_pre-search-text">
                Filter with our advanced search to find exactly what you're looking for...
            </div>
        </div>

        <div class="product-container" fxLayout="column">
            <div class="product-search">
                <app-product-sorted-search [attributes]="attributes$ | async"
                                           [searchFilters]="searchFilters$ | async"
                                           (search)="onSearch($event)"
                                           (openAdvancedSearch)="onOpenAdvancedSearch()">
                </app-product-sorted-search>
            </div>
            <div *ngIf="!(isLoading$ | async)" class="total-products">
                {{(totalProductCount$ | async )}} products
            </div>
            <div class="grid-container"
                 fxLayout="row wrap" fxLayoutAlign="center"
                 infinite-scroll
                 [infiniteScrollDisabled]="(isLoading$ | async) || !hasMoreProductsToLoad(currentPage$ | async, pageSize$ | async, totalProductCount$ | async)"
                 (scrolled)="onScrollDown()">
                <app-product-card
                    class="product-card"
                    *ngFor="let product of (products$ | async)"
                    (addToQuote)="openAddToQuoteDialog($event)"
                    (view)="navigateToProduct($event)"
                    [productContainer]="getProductSelector(product.id) | async">
                </app-product-card>
                <div class="product-card flex-fill-up"
                     *appRepeat="(productsFlexFillUp$ | async)"></div>
            </div>
            <div *ngIf="(isLoading$ | async) || (currentPage$ | async) === 0" class="loading" fxLayout="row"
                 fxLayoutAlign="center center">
                <mat-spinner [diameter]="60"></mat-spinner>
                <span i18n="@@collection-page_loading-products-hint">Loading products ...</span>
            </div>
        </div>
    </div>
    <button id="scroll-to-top-button" (click)="scrollToTop()" mat-fab
            [ngClass]="{'visible': scrollToTopButtonVisible$ | async}">
        <mat-icon>keyboard_arrow_up</mat-icon>
    </button>
    <div id="price-hint" i18n="@@collection-page_price-hint">{{this.priceHintService.getPriceHint()}}</div>
</div>
